<template>
    <v-container class="fill-height" style="display: block;" fluid>
        <v-row>

            <v-col cols="12" lg="6">
                <v-card outlined class="card">
                    <v-card-title>
                        Purge Settings
                        <v-icon class="setting-scope-icon">mdi-account-group</v-icon>
                    </v-card-title>
                    <v-divider />
                    <v-card-text class="card-body">
                        <v-text-field v-for="(purgeSettingKey, idx) in Object.keys($store.state.batchConfig.purge_settings)" disabled :label="purgeSettingKey" :value="$store.state.batchConfig.purge_settings[purgeSettingKey]" />
                    </v-card-text>
                </v-card>
            </v-col>

        </v-row>
    </v-container>
</template>

<script>
export default {
    name: 'System',
    components: {
    },
    data: () => ({
    }),

    computed: {
    },

    methods: {
    },

    mounted() {

    }

  
};
</script>

<style scoped>

    .card {
        overflow-y: auto;
        /* max-height: calc(100vh - 224px); */
        max-height: calc(100vh - 200px);
        position: relative;
    }

    .card-body {
        overflow-y: auto;
        max-height: calc(100vh - 310px);
        max-height: calc(100vh - 270px);
        position: relative;
    }

</style>
